const AutoChat = () =>
  import('@/views/main/live/autoChat/AutoChat.vue')
export default {
  path: '/main/live/autoChat',
  name: 'AutoChat',
  component: AutoChat
}
